import { combineReducers } from 'redux';
import { routerReducer } from 'react-router-redux';
import materials from './materials';
import scenes from './scenes';
import player from './player';
import models from './models';
import users from './users';
import assets from './assets';
import comments from './comments';
import requests from './requests';
import history from './history';
import tags from './tags';
import explorer from './explorer';
import products from './productFamily';
import jobs from './jobs';
import projects from './projects';
import notifications from './notifications';

export default combineReducers({
  router: routerReducer,
  player,
  materials,
  scenes,
  models,
  users,
  assets,
  comments,
  requests,
  history,
  tags,
  explorer,
  products,
  jobs,
  projects,
  notifications,
});



// WEBPACK FOOTER //
// ./src/modules/index.js